import { useAuthContext } from '../AuthContext';
export function useIsUngated(gate) {
  const {
    gates
  } = useAuthContext();
  return gates.has(gate);
}